import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL, trackInitiateCheckout } from './checkout';
import { ScrollTable } from './ScrollTable';
export const packageIncludes = ['Volume 1 — Horse Safety, Handling & Stable Foundations — 16 lessons', 'Volume 2 — First Ride & Rider Foundations — 16 lessons', 'Volume 3 — Balance, Position & Independent Control — 15 lessons', 'Volume 4 — Trot Development & Transitions — 15 lessons', 'Volume 5 — Arena Skills, Poles & Progressive Challenges — 14 lessons', 'Volume 6 — Developing Rider Lessons — 14 lessons', 'Manual 1 — Horse Riding Instructor Master Theory Manual', 'Manual 2 — Corrections, Adaptations & Teaching Solutions Library', 'Bonus 1 — Rider Confidence & Instructor Communication Toolkit', 'Bonus 2 — Riding School Forms, Records & Organization Toolkit', 'Bonus 3 — 100 Riding Games, Arena Challenges & Pole Layouts', 'Bonus 4 — Mixed-Level, Children & Adult Lesson Adaptation System', 'Bonus 5 — Emergency Lesson & Bad Weather Vault', '7-day money-back guarantee'];
const whatYouGet = [['Complete volumes', '6'], ['Structured lessons', '90'], ['Professional manuals', '2'], ['Communication scripts', '100'], ['Organization templates', '60'], ['Games and activities', '100'], ['Emergency lesson plans', '50'], ['Total PDFs', '12']];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-203" data-mp="20g64xuqpouvt">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-204" data-mp="1vhcw4fmdds1z">
        <div className="text-center mb-10" data-id="element-205" data-mp="1vfryui8o7v0f">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-forest" data-id="element-206" data-mp="1rg1bkoicrx0n">
            Your Complete Offer Today
          </h2>
          <p className="text-pine text-sm md:text-base" data-id="element-207" data-mp="k2z9tf79lko2">
            The complete 6-in-1 teaching system + 5 strategic bonuses — ready
            for your next lesson.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest border-2 border-gold rounded-3xl p-1 relative shadow-[0_16px_40px_rgba(18,53,36,0.25)]" data-id="element-208" data-mp="hj2xezjcg9fb">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-forest font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-209" data-mp="ci5f8myc3fdt">
            <Sparkles size={14} data-id="element-210" data-mp="3i8pei07kah6" /> Complete 6-in-1 Package
          </div>

          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-211" data-mp="3kyqgtiomz66w">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-forest mb-3" data-id="element-212" data-mp="3kwngo5trrwog">
              Horse Riding Instructor Ready
            </h3>
            <p className="text-base text-warmgray mb-6" data-id="element-213" data-mp="3byv0z0k4yn0j">
              The complete 6-in-1 teaching system for horse riding instructors.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream border border-gold/40 rounded-xl p-4" data-id="element-214" data-mp="3g189fwq9oz10">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-215" data-mp="2sdl374u7008c">
                  <Check size={16} className="text-pine shrink-0 mt-0.5" data-id="element-216" data-mp="31coo8ecx6pph" />
                  <span data-id="element-217" data-mp="31et0pkovwx1d">{item}</span>
                </li>)}
            </ul>

            <ScrollTable className="mb-6 text-left" data-id="element-218" data-mp="3g84lstcpl3qm">
              <thead data-id="element-219" data-mp="3bbe7aagjyg7b">
                <tr className="bg-forest-dark text-ivory" data-id="element-220" data-mp="3ba32c7bdf2em">
                  <th scope="col" className="px-4 py-3 font-bold" data-id="element-221" data-mp="3p21602mbc63e">
                    What You Get
                  </th>
                  <th scope="col" className="px-4 py-3 font-bold text-right" data-id="element-222" data-mp="3l0flbv3jenin">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-223" data-mp="3u1dsund6pd5z">
                {whatYouGet.map(([label, total], i) => <tr key={label} className={i % 2 === 0 ? 'bg-white' : 'bg-cream/70'} data-id="element-224" data-mp="3tz9fzfxb53tk" data-mpi={i}>
                    <th scope="row" className="px-4 py-3 font-medium text-ink" data-id="element-225" data-mp="lyw9ps7g7ft5">
                      {label}
                    </th>
                    <td className="px-4 py-3 text-right font-bold text-forest" data-id="element-226" data-mp="qr671taw7i5g">
                      {total}
                    </td>
                  </tr>)}
              </tbody>
            </ScrollTable>

            <div className="mb-6" data-id="element-227" data-mp="3v6z05y05d83b">
              <span className="text-lg text-warmgray line-through block mb-1" data-id="element-228" data-mp="301vqlft6je1">
                USD $105.00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-229" data-mp="7ybrax5g3m06">
                <span className="text-2xl md:text-3xl text-ink" data-id="element-230" data-mp="cz9hnx0lzmcr">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-forest" data-id="element-231" data-mp="1jfbrsg1y575a">
                  USD $27.00
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-232" data-mp="1og9aquus657u">
              {CTA_LABEL}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-warmgray mb-4" data-id="element-233" data-mp="2z52w78d0pw0l">
              <span className="flex items-center gap-1.5" data-id="element-234" data-mp="2u6rnj0yglrjy">
                <Lock size={12} className="text-gold" data-id="element-235" data-mp="2q68vb5snmjh8" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-236" data-mp="2l6w7ahq1r6d2">
                <Zap size={12} className="text-gold" data-id="element-237" data-mp="2l5bgn36us7kh" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-238" data-mp="2g7s0tyuibmqf">
                <Shield size={12} className="text-gold" data-id="element-239" data-mp="2b98dpv46g4wh" /> 7-day guarantee
              </span>
            </div>

            <div className="bg-leather/50 border border-gold-aged/40 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-240" data-mp="ef3uvhqhal6y">
              <Globe className="text-forest shrink-0 mt-0.5" size={14} data-id="element-241" data-mp="9eza3fijf4ax" />
              <p className="text-[11px] text-warmgray leading-snug" data-id="element-242" data-mp="23wimtzuzk6yg">
                Pay in your local currency. The amount adapts automatically
                based on the country you purchase from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}